module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务板块",
      "prop": "type_name",
      "rules": [{
        required: true,
        message: '请选择业务板块'
      } ]
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.type_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type_name", $$v)
      },
      expression: "formData.type_name"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "竞赛"
    }
  }, [_vm._v("竞赛")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "培训"
    }
  }, [_vm._v("培训")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "星级俱乐部"
    }
  }, [_vm._v("星级俱乐部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "七彩星级"
    }
  }, [_vm._v("七彩星级")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "其他"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否匿名",
      "prop": "niming"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.niming),
      callback: function($$v) {
        _vm.$set(_vm.formData, "niming", $$v)
      },
      expression: "formData.niming"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("匿名")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("实名")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "意见或建议",
      "prop": "content",
      "rules": [{
        required: true,
        message: '请输入详细地址',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入您的意见或建议..."
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交报名\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "信箱@CCA",
      "visible": _vm.showNotice,
      "width": "40%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showNotice = $event
      }
    }
  }, [_c('div', {
    staticClass: "notice_content"
  }, [_c('p', [_vm._v("欢迎您@CCA。您对啦啦操竞赛、培训、星级俱乐部、七彩星级有什么感受？您对啦啦操项目推广及未来发展有何高招与高见？啦啦操离不开大家的真知灼见。")]), _vm._v(" "), _c('p', [_vm._v("您的留言将被转给有关业务部门和地方，并可能以不同形式公开。")]), _vm._v(" "), _c('p', [_vm._v("汲取各方智慧，倾听阁下意见，采纳诸君建议。您对啦啦操的期望，也是我们努力的方向。")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showNotice = false
      }
    }
  }, [_vm._v("信箱入口")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3203f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/Gbook.vue
// module id = 1504
// module chunks = 0